/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PasskeyDeviceInfo } from './passkeyDeviceInfo';

export interface PasskeyStatusResponse { 
    /**
     * Indica se l'utente ha almeno una passkey valida
     */
    has_passkey: boolean;
    /**
     * Lista dei dispositivi con passkey registrate
     */
    devices: Array<PasskeyDeviceInfo>;
    /**
     * Data di scadenza della passkey più vicina alla scadenza
     */
    nearest_expiry?: Date;
}